import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';

const Navigation = (props) => (
	<nav>
		<ul className={props.classes.nav}>
			<li className={props.classes.navItem}>
				<NavLink to="/" className={props.classes.navLink} activeClassName="">Home</NavLink>
			</li>
			{props.items.map((item, key) => (
				<li key={key} className={props.classes.navItem}>
					<NavLink to={item.link.path} className={props.classes.navLink} activeClassName={props.classes.navLinkActive}>{item.link.label}</NavLink>
				</li>
			))}
		</ul>
	</nav>
);

Navigation.propTypes = {
	classes: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired
};

const styles = theme => ({
	nav: {
		padding: 0,
		margin: 0,
		listStyle: 'none',
		display: 'flex'
	},
	navItem: {
		position: 'relative',
		alignItems: 'center',
		marginLeft: 20,
		'&:first-child': {
			marginLeft: 0,
			display: 'none',
			[theme.breakpoints.up('sm')]: {
				display: 'block'
			}
		}
	},
	navLink: {
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		fontWeight: theme.typography.fontWeightRegular,
		color: 'inherit',
		textDecoration: 'none'
	},
	navLinkActive: {
		'&:after': {
			position: 'absolute',
			bottom: -7,
			left: 0,
			display: 'block',
			width: '100%',
			height: '.3rem',
			content: '""',
			backgroundColor: theme.palette.secondary.light
		}
	}
});

export default withStyles(styles)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js